import React, { useCallback } from 'react';
import classnames from 'clsx';
import PropTypes from 'prop-types';

import { FulfillmentPlannerWeightInput } from './input/container';
import { WeightLabel } from './label';
import { Scale } from './scale';
import { emptyObject } from 'ui-components/default-props/empty';
import { useReadFromScale } from '../../hooks/use-read-from-scale';
import { SmartFillTooltip } from '../../orders/order-details/fulfillment-plan/sections/configure-shipment/smartfill-tooltip';
import { useFulfillmentPlannerContext } from '../context';

import smartFillStyle from 'ui-components/components/smartfill.module.less';

export const Weight = ({ shrinkable = false, classNames = emptyObject, showScale = false, fulfillmentPlanId = null }) => {
  const {
    onWeightAndDimensionsChange,
    packages = [],
    hasSmartFillDataBeenChanged,
    isSmartFillEnabled,
    smartFillMetaData,
  } = useFulfillmentPlannerContext();
  const onScaleMessage = useCallback(
    (weightAndDims) => {
      onWeightAndDimensionsChange(weightAndDims?.weight, weightAndDims?.dims);
    },
    [onWeightAndDimensionsChange],
  );
  const onReadFromScale = useReadFromScale(onScaleMessage);

  const hasSmartFillWeightChanged = hasSmartFillDataBeenChanged?.weight;
  const shouldShowSmartFillIcon = isSmartFillEnabled && !hasSmartFillWeightChanged;

  return (
    <>
      <div className={classNames.label}>
        <SmartFillTooltip count={smartFillMetaData?.Weight?.TimesUsed} shouldHideTooltip={!shouldShowSmartFillIcon}>
          <WeightLabel />
        </SmartFillTooltip>
      </div>
      <div className={classNames.weight}>
        <FulfillmentPlannerWeightInput
          fulfillmentPlanId={fulfillmentPlanId}
          inputClassName={classnames(classNames['weight-input'], {
            [smartFillStyle['smart-fill-container']]: shouldShowSmartFillIcon,
          })}
          shrinkable={shrinkable}
        />
        {showScale ? (
          <Scale
            className={classNames.scale}
            isSmartFillApplied={shouldShowSmartFillIcon}
            onReadFromScale={onReadFromScale}
            packageCount={packages.length}
          />
        ) : null}
      </div>
      {/* Caution: I thought this div was useless and went to remove it, but it broke the layout. */}
      <div />
    </>
  );
};

Weight.propTypes = {
  shrinkable: PropTypes.bool,
  showScale: PropTypes.bool,
  classNames: PropTypes.shape({
    label: PropTypes.string,
    weight: PropTypes.string,
    'weight-input': PropTypes.string,
    scale: PropTypes.string,
  }),
};
